module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_4.71003590.jpg";